<div class="flex-row full column align-start position-relative p-24">
  <button type="button" class="btn p-0 text-dark close-modal mt-24 mr-24" (click)="closeDialog()">X</button>
  <div class="flex-row full column align-start row-gap-16">
    <h2 class="fs-22 fw-7">Make Payment Via</h2>
    <div class="flex-row align-center full content-between column-gap-30">
      <button type="button" class="btn pl-20 pr-20"
        [ngClass]="{'btn-outline': paymentType === 'net-bank','border-1':paymentType !== 'net-bank'}"
        (click)="changeType('net-bank')">
        Pay Via Net Banking
      </button>
      <button type="button" class="btn border-1"
        [ngClass]="{'btn-outline': paymentType === 'upi','border-1':paymentType !== 'upi'}" (click)="changeType('upi')">
        Pay Via UPI
      </button>
    </div>
    <div class="flex-row full column align-start" *ngIf="paymentType === 'upi'">
      <label class="fs-14 mb-2" for="uPIId">UPI ID</label>
      <input type="text" class="border-1 text-dark width-100-pr m-0 p-11 fs-16 border-radius-4" placeholder="upi@upi"
        [formControl]="uPIId" id="uPIId">
      <span class="text-danger fs-14 fs-md-12" *ngIf="uPIId.touched && uPIId.invalid">Please provide a valid UPI
        ID.</span>
    </div>
    <div class="flex-row full content-end">
      <button type="button" class="btn btn-primary" (click)="confirm()">Confirm</button>
    </div>
  </div>
</div>